import { render, staticRenderFns } from "./VxTab.vue?vue&type=template&id=594ad10d&lang=html"
import script from "./VxTab.vue?vue&type=script&lang=js"
export * from "./VxTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/alquant/white-label-platforms/platform-hexagon-capital/platform/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594ad10d')) {
      api.createRecord('594ad10d', component.options)
    } else {
      api.reload('594ad10d', component.options)
    }
    module.hot.accept("./VxTab.vue?vue&type=template&id=594ad10d&lang=html", function () {
      api.rerender('594ad10d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vx-tabs/VxTab.vue"
export default component.exports